'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const RevenueChartInner = dynamic(() => import('./RevenueChartInner'), { ssr: false });

export default function AdminRevenueChart() {
  return (
    <div className="bg-card rounded-2xl border border-border card-shadow p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-sm font-bold text-foreground">Revenue vs Cleaner Payouts</p>
          <p className="text-xs text-muted-foreground mt-0.5">Last 8 weeks · All service types</p>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-primary inline-block" />Revenue</span>
          <span className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-success inline-block" />Payouts</span>
        </div>
      </div>
      <RevenueChartInner />
    </div>
  );
}